var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full pt-4 mx-auto lg:w-5/6 background-fill profile-content profile-deals"},[_c('div',{staticClass:"flex flex-wrap lg:p-2"},[_c('div',{staticClass:"w-full mb-4"},[_c('OrderDetail',{attrs:{"order":_vm.preOrder}}),_vm._v(" "),(_vm.notes.length)?_c('OrderHistory',{attrs:{"notes":_vm.notes}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }